import { TABLE_INITIAL_STATE, TableActionTypes, useDataTable } from 'web-library';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetProfileAmendmentRequestTransactionLog } from '../../../../api-refactored/profile-amendment-requests/useGetProfileAmendmentRequestTransactionLog';
import TransactionLogModalDetails from '../../../../components/TransactionLogModalDetails';

interface ProfileAmendmentRequestTransactionLogModalProps {
  modalState: boolean;
  setOpenModalState: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfileAmendmentRequestTransactionLogModal = ({
  modalState,
  setOpenModalState,
}: ProfileAmendmentRequestTransactionLogModalProps) => {
  const { uuid } = useParams<{ uuid: string }>();

  const dataTableHook = useDataTable({
    ...TABLE_INITIAL_STATE,
    sortColumn: 'dateTime',
    order: 'asc',
    size: 5,
    page: 0,
    search: '',
  });

  const { dispatch: tableDispatch, state } = dataTableHook;

  const { refetch } = useGetProfileAmendmentRequestTransactionLog({
    apiPathParam: {
      page: state.page,
      pageSize: state.size,
      order: state.order,
    },
    onSuccess: (res) => {
      tableDispatch({
        type: 'UPDATE_DATA',
        payload: {
          data: res.content,
          count: res.totalElements,
        },
      } as TableActionTypes);
    },
    uuid,
    enabled: modalState,
  });

  return (
    <TransactionLogModalDetails
      dataTableHook={dataTableHook}
      refetch={refetch}
      openModalState={modalState}
      setOpenModalState={setOpenModalState}
    />
  );
};

export default ProfileAmendmentRequestTransactionLogModal;
